/**
 * Modelos para o sistema de Pacote Cenoura
 */

export interface CarrotInfoResponse {
  active: boolean;
  countdown: number | null;
}

/**
 * Entidade que representa as informações sobre o status do pacote cenoura
 */
export class CarrotInfo {
  /**
   * Indica se o pacote cenoura está ativo
   */
  active: boolean;

  /**
   * Tempo em segundos para exibir a contagem regressiva.
   * Se null ou undefined, não deve exibir o countdown.
   */
  countdown: number | null;

  constructor(active: boolean, countdown: number | null) {
    this.active = active;
    this.countdown = countdown;
  }

  /**
   * Cria uma instância de CarrotInfo a partir de um JSON
   */
  static fromJson(json: CarrotInfoResponse): CarrotInfo {
    return new CarrotInfo(
      json.active ?? false,
      json.countdown ?? null
    );
  }

  /**
   * Verifica se deve exibir o countdown
   */
  shouldShowCountdown(): boolean {
    return this.active && this.countdown !== null && this.countdown > 0;
  }
}
